module.exports = __webpack_public_path__ + "DINNextLTPro-Italic.woff?07115ac4f1fcaad696ab08ad5749f623";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Italic.woff
// module id = 1404
// module chunks = 0